import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'

const s3BucketUrl = import.meta.env.VITE_S3_BUCKET_URL
const localeLoc
  = process.env.NODE_ENV === 'development'
    ? './locales'
    : `${s3BucketUrl}/cd-widgets/locales`

export const SUPPORTED_LOCALES = import.meta.env.VITE_SUPPORTED_LOCALES.split(
  ',',
)

const getResourceMessages = r => r.default || r

function fetchTranslations(locale, widget, externalTranslation) {
  return fetch(/* @vite-ignore */ externalTranslation || `${localeLoc}/${widget}/${locale}.json`)
    .then(resp => resp.json())
    .then(getResourceMessages)
}

export function getLocale(i18n) {
  return i18n.mode === 'legacy' ? i18n.global.locale : i18n.global.locale.value
}

export function setLocale(i18n, locale) {
  if (i18n.mode === 'legacy')
    i18n.global.locale = locale
  else i18n.global.locale.value = locale
}

export function setupI18n(options = { locale: 'en' }) {
  const i18n = createI18n(options)
  setI18nLanguage(i18n, options.locale)

  return i18n
}

export function setI18nLanguage(i18n, locale) {
  setLocale(i18n, locale)
  if (document.querySelector('html'))
    document.querySelector('html').setAttribute('lang', locale)
}

export async function loadLocaleMessages(i18n, locale, widget, externalTranslation) {
  let messages = null
  let errors = null
  let usedLocale = locale

  // load locale messages
  try {
    messages = await fetchTranslations(locale, widget, externalTranslation)
  }
  catch {
    if (locale.length > 2)
      usedLocale = locale.slice(0, 2)
    else usedLocale = 'en'

    messages = await fetchTranslations(usedLocale, widget)
  }

  try {
    errors = await fetchTranslations(usedLocale.slice(0, 2), 'errors')
  }
  catch {}

  // set locale and locale message
  i18n.global.setLocaleMessage(locale, { ...messages, ...errors })

  return nextTick()
}
